import { render, staticRenderFns } from "./RedisQuery.vue?vue&type=template&id=5c98b52c&scoped=true"
import script from "./RedisQuery.vue?vue&type=script&lang=js"
export * from "./RedisQuery.vue?vue&type=script&lang=js"
import style0 from "./RedisQuery.vue?vue&type=style&index=0&id=5c98b52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98b52c",
  null
  
)

export default component.exports